import { BaseResponseSchema } from '../../schemas/primitives.js';
import { CreateFeatureFlagRequestSchema, FeatureFlagKeyParamSchema, ProviderFeatureFlagListResponseSchema, } from '../../schemas/provider-feature-flags.schemas.js';
/** REST contract for `insight-api/src/routes/feature-flags.routes.ts`. */
export const providerFeatureFlagsContract = {
    list: {
        method: 'GET',
        path: '/provider/feature-flags',
        response: ProviderFeatureFlagListResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to fetch feature flags',
    },
    create: {
        method: 'POST',
        path: '/provider/feature-flags',
        body: CreateFeatureFlagRequestSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to create feature flag',
    },
    enable: {
        method: 'POST',
        path: '/provider/feature-flags/:flagKey/enable',
        pathParams: FeatureFlagKeyParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to enable feature flag',
    },
    disable: {
        method: 'POST',
        path: '/provider/feature-flags/:flagKey/disable',
        pathParams: FeatureFlagKeyParamSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to disable feature flag',
    },
    initialize: {
        method: 'POST',
        path: '/provider/feature-flags/initialize',
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to initialize feature flags',
    },
};
//# sourceMappingURL=provider-feature-flags.contract.js.map